<script>
	import { navigate } from 'svelte-routing';
	import LegacyComponentWrapper from '../../frame-components/legacy-component-wrapper.svelte';
	import { show_sidebar, active_breadcrumb } from '../../app-store';
	import { onDestroy } from 'svelte';

	export let params;

	let legacy_component = {
		id: "article-list",
		screen_container_el: null,
		selected_articles: [],
		selected_research: [],
		article_list_el: null,
		research_list_el: null,
		_create_error_alert_el: function (message) {
			return tag.article(
				{ class: "alert alert-danger project-item animate-in" },
				tag.div({ class: "project-item-body" }, [
					tag.div({ class: "alert-title fw-bold"}, "Error"),
					tag.div({ class: "alert-message" }, message),
					tag.div({ class: "d-flex gap-1"}, [
						tag.button({type: "button", class: "btn btn-primary", onclick: ()=> window.location.reload()}, "Retry")
					])
				])
			);
		},
		convert_to_csv: function (data) {
			if (!Array.isArray(data) || !data.length) return "";

			const headers = Object.keys(data[0]);
			const csvRows = [headers.join(",")];

			for (const row of data) {
				const values = headers.map(header => {
					const val = row[header] == null ? "" : String(row[header]).replace(/"/g, '""');
					return `"${val}"`;
				});
				csvRows.push(values.join(","));
			}
			return csvRows.join("\n");
		},
		download_csv: function (csv, filename) {
			const blob = new Blob([csv], { type: "text/csv" });
			const url = URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = filename;
			a.click();
			URL.revokeObjectURL(url);
		},
		create_article: function ({
			article_id,
			article_url,
			article_image_url,
			article_title,
			article_description = "",
			article_reason = "",
			article_score = 0,
			onclick,
		}) {
			let article_score_text = 0;
			if (article_score < 3) {
				article_score_text = "Poor";
			} else if (article_score < 6) {
				article_score_text = "Average";
			} else if (article_score < 8) {
				article_score_text = "Good";
			} else {
				article_score_text = "Excellent";
			}
			const article_score_percentage = (article_score / 10) * 100;
			const checkbox_el = tag.input({
				type: "checkbox",
				name: "blog-select",
				id: `article-${article_id}`,
				value: article_id,
			});
			const thumbnail_el = tag.img({
				src: "",
				alt: "",
				class: "img blog-thumbnail loading",
				width: "260",
				height: "135",
			});

			const get_article_url_host = (article_url) => {
				try {
					return new URL(article_url).hostname
				} catch (error) {
					return article_url;
				}
			}

			const el = tag.div(
				{ onclick: onclick, class: "blog-item", "data-article_id": article_id },
				thumbnail_el,
				tag.div(
					tag.h2({ class: "blog-title" }, article_title),
					tag.small({ class: "blog-domain" }, get_article_url_host(article_url))
				),
				tag.div(
					{ class: "blog-description" },
					tag.p(article_description),
					tag.a({ href: "javascript:void(0)", class: "blog-expand blog-description-expand hidden" }, "Read more")
				),
				tag.div(
					{ class: "blog-reason" },
					tag.p({ class: "blog-reason-title fw-bold" }, "Reason for consideration"),
					tag.p(article_reason),
					tag.a({ href: "javascript:void(0)", class: "blog-expand blog-reason-expand hidden" }, "Read more")
				),
				tag.div(
					{ class: "blog-meter-container" },
					tag.small({ class: "blog-meter-text" }, article_score_text),
					tag.meter({
						value: article_score,
						class: "blog-meter",
						min: "0",
						max: "10",
						low: "3",
						high: "6",
						optimum: "8",
					}),
					tag.small({ class: "blog-meter-score" }, `${article_score_percentage}%`)
				),
				tag.div(
					{ class: "blog-select-view-container" },
					tag.div(
						{ role: "radio", class: "blog-select d-flex gap-1 align-items-center hidden" },
						tag.span("Select"),
						checkbox_el
					),
					tag.a({ href: article_url, class: "blog-view", target: "_blank" }, "Read")
				)
			);

			return {
				el: el,
				checkbox_el: checkbox_el,
				id: article_id,
				title: article_title,
				image_url: article_image_url,
				url: article_url,
				thumbnail_el: thumbnail_el,
			};
		},
		create_research_card: function ({ research_id, research_url, research_title, research_description, onclick }) {
			const checkbox_el = tag.input({ type: "checkbox", id: `research-${research_id}`, value: research_id });
			const el = tag.div(
				{ onclick: onclick, class: "research-item", "data-research_id": research_id },
				tag.div({ class: "research-item-title" }, research_title),
				tag.small({ class: "research-item-url" }, research_url),
				tag.div({ class: "research-item-description" }, research_description),
				tag.div(
					{ class: "research-item-footer" },
					tag.div({ class: "research-checkbox-container hidden" }, checkbox_el),
					tag.small({ class: "research-item-link" }, tag.a({ href: research_url, target: "_blank" }, "Read"))
				)
			);

			return {
				el: el,
				checkbox_el: checkbox_el,
			};
		},
		create_sources_tab: function ({ onRecommendedSourcesClick, onAllResearchClick }) {
			const el = tag.ul(
					{ class: "nav nav-underline source-tab" },
					tag.li(
						{ class: "nav-item" },
						tag.button(
							{ onclick: onRecommendedSourcesClick, class: "nav-link active", type: "button" },
							"Recommended Sources"
						)
					),
					tag.li(
						{ class: "nav-item" },
						tag.button(
							{ onclick: onAllResearchClick, class: "nav-link", type: "button" },
							"All Research"
						)
					)
				);
			return {
				el: el,
				setRecommendedSourcesActive: () => {
					el.querySelector(".nav-link.active").classList.remove("active");
					el.querySelector(".nav-link:nth-child(1)").classList.add("active");
				},
				setAllResearchActive: () => {
					el.querySelector(".nav-link.active").classList.remove("active");
					el.querySelector(".nav-link:nth-child(2)").classList.add("active");
				},
			};
		},
		show: function () {
			document.getElementById(this.id).classList.remove("hidden");
		},
		hide: function () {
			document.getElementById(this.id).classList.add("hidden");
		},
		onshow: async function (payload = {}) {
			const project_ref = params.project_ref;
			const refcode = params.draft_refcode;

			let recommended_articles;
			let suggested_content;
			let all_research;
			let selected_articles;


			// Observer function to lazy load images
			const observer = new IntersectionObserver(async (entries, observer) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						const img_el = entry.target;
						const image_url = img_el.getAttribute("data-image-url");
						try {
							img_el.src = image_url;
							img_el.addEventListener("error", (e) => {
								img_el.src = "./img/placeholder.webp";
							});
							img_el.parentElement.setAttribute("data-url-content", 1);
						} catch (error) {
							img_el.parentElement.setAttribute("data-url-content", 0);
							img_el.src = "./img/noimage.png";
						}
						observer.unobserve(img_el);
					}
				}
			});

			app.body_spinner.add_to(document.body);
			try {
				const { status, draft } = await app.lucep_ai.get_draft(refcode);
				if (status != "ok") {
					console.error("Error getting draft. status: ", status);
					return;
				}
				recommended_articles = draft.recommended_articles;
				suggested_content = draft.suggested_content;
				all_research = draft.all_research;
				selected_articles = draft.selected_articles;
			} catch (err) {
				console.error("Error getting draft. ", err);
				if (err.status_code === 500) {
					const err_el = this._create_error_alert_el(error_msg.server_error(err.msg));
					this.screen_container_el.appendChild(err_el);
				} else {
					const err_el = this._create_error_alert_el(error_msg.client_error(err.msg));
					this.screen_container_el.appendChild(err_el);
				}
				return
			} finally {
				app.body_spinner.remove();
			}

			app.chat_manager.clear();
			app.chat_manager.send_ai_message("researcher", "select_articles");
			// Create the dropdown for selected articles
			const selected_article_dropdown = window.create_dropdown({
				text: "Selected Articles",
				use_counter: true,
				classnames: ["selected-articles-dropdown"],
			});
			app.chat_manager.send_alert(selected_article_dropdown.el);
			active_breadcrumb.set("breadcrumb-recommended-sources");

			this.selected_articles = [];
			this.selected_research = [];
			this.article_list_el = null;
			this.research_list_el = null;

			// Create the recommended article list
			const _recommended_articles = recommended_articles || [];
			const prepared_articles = _recommended_articles.map((article, i) => {
				const article_card = this.create_article({
					article_id: article.id,
					article_url: article.url,
					article_image_url: article.image_url,
					article_title: article.title,
					article_description: article.description,
					article_score: article.recommended_score,
					article_reason: article.reason_recommended,
					onclick: () => {
						// Disable handler if suggested content
						if (suggested_content) {
							return;
						}
						article_card.checkbox_el.checked = !article_card.checkbox_el.checked;
						article_card.el.classList.toggle("blog-item--selected");
						if (article_card.checkbox_el.checked) {
							const blog_selected_el = tag.span(
								{
									class: "blog-title-selected",
									id: "blog-title-selected-" + article.id,
								},
								tag.strong(article.title),
								tag.p(
									{ class: "blog-selected-reason text-wrap text-muted" },
									article.reason_recommended
										? article.reason_recommended
										: "No reason provided"
								),
								tag.a(
									{ href: article.url, target: "_blank", class: "blog-selected-link" },
									"Read"
								)
							);
							selected_article_dropdown.add_item(blog_selected_el);
							this.selected_articles.push({ ...article, article_card });
						} else {
							const blog_selected_el = document.getElementById("blog-title-selected-" + article.id);
							if (blog_selected_el) {
								selected_article_dropdown.remove_item(blog_selected_el);
							}
							this.selected_articles = this.selected_articles.filter((selected_article) => {
								return selected_article.id !== article.id;
							});
						}
					},
				});

				// Load images from cache
				if (app.cache_imgs[article.url]) {
					article_card.thumbnail_el.src = app.cache_imgs[article.url];
					article_card.thumbnail_el.addEventListener("load", (e) =>
						article_card.thumbnail_el.classList.remove("loading")
					);
				} else {
					article_card.thumbnail_el.classList.add("loading");
				}

				return {
					el: article_card.el,
					thumbnail_el: article_card.thumbnail_el,
					checkbox_el: article_card.checkbox_el,
					id: article.id,
					title: article.title,
					url: article.url,
					image_url: article.image_url,
				};
			});

			// Observe now
			prepared_articles.forEach((article) => {
				const img_el = article.thumbnail_el;
				img_el.setAttribute("data-image-url", article.image_url);
				observer.observe(img_el);
			});

			// Create all research list
			const _all_research = all_research || [];
			const prepared_all_research = _all_research.map((research, i) => {
				const research_card = this.create_research_card({
					research_id: research.id,
					research_url: research.url,
					research_title: research.title,
					research_description: research.description,
					onclick: () => {
						// Disable handler if suggested content
						if (suggested_content) {
							return;
						}
						const research_item_el = research_card.el;
						research_card.checkbox_el.checked = !research_card.checkbox_el.checked;
						research_item_el.classList.toggle("research-item--selected");
						if (research_card.checkbox_el.checked) {
							const research_selected_el = tag.span(
								{
									class: "blog-title-selected",
									id: "blog-title-selected-" + research.id,
								},
								research.title
							);
							selected_article_dropdown.add_item(research_selected_el);
							this.selected_research.push(...research, research_card);
						} else {
							const research_selected_el = document.getElementById("blog-title-selected-" + research.id);
							if (research_selected_el) {
								selected_article_dropdown.remove_item(research_selected_el);
							}
							this.selected_research = this.selected_research.filter((selected_research) => {
								selected_research.id !== research.id;
							});
						}
					},
				});
				return {
					el: research_card.el,
					checkbox_el: research_card.checkbox_el,
					id: research.id,
					title: research.title,
					url: research.url,
				};
			});

			this.screen_container_el.innerHTML = "";

			const source_tab = this.create_sources_tab({
				onRecommendedSourcesClick: () => {
					this.article_list_el.classList.remove("hidden");
					this.research_list_el.classList.add("hidden");
					source_tab.setRecommendedSourcesActive();
				},
				onAllResearchClick: () => {
					this.article_list_el.classList.add("hidden");
					this.research_list_el.classList.remove("hidden");
					source_tab.setAllResearchActive();
				},
			});

			this.article_list_el = tag.div({ class: "blog-list" });
			for (const article of prepared_articles) {
				this.article_list_el.appendChild(article.el);
			}
			this.screen_container_el.append(source_tab.el, this.article_list_el);

			// Hide research list by default
			this.research_list_el = tag.div({ class: "research-list hidden" });
			for (const research of prepared_all_research) {
				this.research_list_el.appendChild(research.el);
			}
			this.screen_container_el.append(this.research_list_el);

			// Apply selected blog ids to the blog list
			if (Array.isArray(selected_articles) && selected_articles.length > 0) {
				for (const article of prepared_articles) {
					const selected_article = selected_articles.find((selected_article) => {
						return selected_article.id === article.id;
					});
					if (selected_article) {
						const checkbox_el = article.checkbox_el;
						checkbox_el.checked = true;
						article.el.classList.add("blog-item--selected");
						selected_article_dropdown.add_item(
							tag.span(
								{
									class: "blog-title-selected",
									id: "blog-title-selected-" + article.id,
								},
								article.title
							)
						);
						this.selected_articles.push({ ...article });
					}
				}
			}
			// Applly selected research ids to the research list
			if (Array.isArray(selected_articles) && selected_articles.length > 0) {
				for (const research of prepared_all_research) {
					const selected_research = selected_articles.find((selected_research) => {
						return selected_research.id === research.id;
					});
					if (selected_research) {
						const checkbox_el = research.checkbox_el;
						checkbox_el.checked = true;
						research.el.classList.add("research-item--selected");
						selected_article_dropdown.add_item(
							tag.span(
								{
									class: "blog-title-selected",
									id: "blog-title-selected-" + research.id,
								},
								research.title
							)
						);
						this.selected_research.push({ ...research });
					}
				}
			}

			// Create the buttons
			const btn_create_draft = tag.button(
				{
					class: "btn btn-create-draft btn-primary",
					onclick: () => {
						// Get selected blogs
						const selected_article_ids = [];
						const max_articles = 5;
						for (const article of prepared_articles) {
							const input_el = article.el.querySelector("input");
							if (input_el.checked) {
								selected_article_ids.push(article.id);
							}
						}

						for (const research of prepared_all_research) {
							const input_el = research.el.querySelector("input");
							if (input_el.checked) {
								selected_article_ids.push(research.id);
							}
						}

						if (selected_article_ids.length === 0) {
							app.toast_msg.show("Please select which ones you want to use in your article");
							return;
						}

						if (selected_article_ids.length > max_articles) {
							app.toast_msg.show("Please select maximum 5 articles");
							return;
						}

						navigate(`/article-content-loader/${project_ref}/${refcode}`, { state : {
							selected_article_ids,
						}});

						btn_create_draft.disabled = true;
					},
				},
				"Create Draft"
			);

			const btn_download_dropdown = window.create_dropdown({
				html: "<img src='./img/download-icon.svg' alt='Download' class='btn-download-icon' width=25 height=25 />",
				use_counter: false,
			});
			btn_download_dropdown.add_item(
				tag.button(
					{
						class: "btn btn-light btn-sm small text-black btn-download-recommended-list-as-csv border-0 fw-normal",
						onclick: () => {
							const csv = this.convert_to_csv(recommended_articles);
							this.download_csv(csv, "recommended_articles.csv");
						},
					},
					"Download Recommended List as CSV"
				)
			);
			btn_download_dropdown.add_item(
				tag.button(
					{
						class: "btn btn-light btn-sm small text-black btn-download-all-research-as-csv border-0 fw-normal",
						onclick: () => {
							const csv = this.convert_to_csv(all_research);
							this.download_csv(csv, "all_research.csv");
						},
					},
					"Download All Research as CSV"
				)
			);

			const btn_view_draft = tag.button(
				{
					class: "btn btn-link btn-view-draft",
					onclick: () => {
						navigate(`/article-content/${project_ref}/${refcode}`);
					},
				},
				"View Existing Drafts"
			);

			// Add the buttons to the chat
			const btn_draft_wrapper = tag.div({ class: "btn-draft-wrapper" });
			if (!suggested_content) {
				btn_draft_wrapper.appendChild(btn_create_draft);
			}
			btn_draft_wrapper.appendChild(btn_download_dropdown.el);

			if (suggested_content) {
				btn_draft_wrapper.appendChild(btn_view_draft);
			}
			app.chat_manager.send_alert(btn_draft_wrapper);
		},
		init: function () {
			this.screen_container_el = tag.div({ class: "action-area action-area-article-list" });
			return this.screen_container_el;
		},
	}
	// TODO: Handle breadcrumb for research and articles
	// const unsub_breadcrumb =breadcrumb_events.subscribe(e => {
	// 	if (!e || e.target !== 'article-list'
	// 	|| !legacy_component.research_list_el
	// 	|| !legacy_component.article_list_el) return;

	// 	if (e.action === 'show-research') {
	// 		legacy_component.research_list_el.classList.remove('hidden');
	// 		legacy_component.article_list_el.classList.add('hidden');

	// 	} else if (e.action === 'show-articles') {
	// 		legacy_component.research_list_el.classList.add('hidden');
	// 		legacy_component.article_list_el.classList.remove('hidden');
	// 	}
	// });

	// onDestroy(unsub_breadcrumb);

</script>

<LegacyComponentWrapper legacy_component={legacy_component} params={params} />
